<template>
  <div class="icons">
    <symbol id="icon-fire" viewBox="0 0 24 24">
      <title>fire</title>
      <path d="M11.719 18.984c2.672 0 4.781-2.109 4.781-4.781 0-1.406-0.188-2.719-0.563-4.031-1.031 1.359-2.859 2.203-4.641 2.578s-2.813 1.453-2.813 3.094c0 1.734 1.453 3.141 3.234 3.141zM13.5 0.656c3.891 3.141 6.516 7.969 6.516 13.359 0 4.406-3.609 7.969-8.016 7.969s-8.016-3.563-8.016-7.969c0-3.375 1.219-6.516 3.234-8.906v0.375c0 2.063 1.547 3.703 3.609 3.703s3.422-1.641 3.422-3.703c0-2.156-0.75-4.828-0.75-4.828z"></path>
    </symbol>
    <symbol id="icon-water" viewBox="0 0 32 32">
      <title>water</title>
      <path d="M27.020 14.786c-2.055-5.732-6.41-10.88-11.020-14.786-4.61 3.907-8.965 9.054-11.020 14.786-1.271 3.545-1.396 7.393 0.393 10.794 2.058 3.911 6.207 6.42 10.626 6.42s8.569-2.509 10.626-6.42c1.79-3.401 1.664-7.249 0.393-10.794zM23.086 23.717c-1.369 2.602-4.15 4.283-7.086 4.283-1.723 0-3.391-0.579-4.753-1.583 0.414 0.054 0.832 0.083 1.254 0.083 3.67 0 7.146-2.1 8.856-5.351 1.402-2.665 1.281-5.433 0.746-7.636 0.455 0.88 0.841 1.756 1.151 2.623 0.706 1.971 1.251 4.886-0.168 7.581z"></path>
    </symbol>
  </div>
</template>

<script>
export default {
  name: 'icons'
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/components/icons.vue